/**
 * 轻量 Markdown → 安全 HTML（先 escape，再识别常见子集）
 * 支持：换行、#/##/### 标题、**粗体**、行首 - / * 列表、| 表格、> 引用、行内 `code`、[ ] 待办
 * 不引入 marked 等依赖。
 */

function escapeHtml (s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function inlineFormat (escapedLine) {
  // 已 escape；再做安全的行内替换
  var s = escapedLine
  s = s.replace(/`([^`]+)`/g, '<code>$1</code>')
  s = s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
  s = s.replace(/\[ \]/g, '☐ ')
  s = s.replace(/\[x\]/gi, '☑ ')
  return s
}

function isTableSep (line) {
  return /^\|?[\s:-]+\|[\s|:-]*$/.test(line)
}

function parseTableRow (line) {
  var raw = line.trim()
  if (raw.charAt(0) === '|') raw = raw.slice(1)
  if (raw.charAt(raw.length - 1) === '|') raw = raw.slice(0, -1)
  return raw.split('|').map(function (c) {
    return inlineFormat(escapeHtml(c.trim()))
  })
}

/**
 * @param {string} md
 * @returns {string} safe HTML
 */
export function renderSimpleMarkdown (md) {
  if (md == null || md === '') {
    return ''
  }
  var lines = String(md).replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n')
  var html = []
  var i = 0
  var inUl = false
  var inOl = false

  function closeLists () {
    if (inUl) {
      html.push('</ul>')
      inUl = false
    }
    if (inOl) {
      html.push('</ol>')
      inOl = false
    }
  }

  while (i < lines.length) {
    var line = lines[i]
    var trimmed = line.trim()

    // 表格：当前行含 |，下一行是分隔行
    if (trimmed.indexOf('|') >= 0 && i + 1 < lines.length && isTableSep(lines[i + 1].trim())) {
      closeLists()
      var header = parseTableRow(trimmed)
      html.push('<table class="md-table"><thead><tr>')
      header.forEach(function (c) {
        html.push('<th>' + c + '</th>')
      })
      html.push('</tr></thead><tbody>')
      i += 2
      while (i < lines.length && lines[i].trim().indexOf('|') >= 0 && !isTableSep(lines[i].trim())) {
        var cells = parseTableRow(lines[i].trim())
        html.push('<tr>')
        cells.forEach(function (c) {
          html.push('<td>' + c + '</td>')
        })
        html.push('</tr>')
        i++
      }
      html.push('</tbody></table>')
      continue
    }

    if (/^###\s+/.test(trimmed)) {
      closeLists()
      html.push('<h4>' + inlineFormat(escapeHtml(trimmed.replace(/^###\s+/, ''))) + '</h4>')
      i++
      continue
    }
    if (/^##\s+/.test(trimmed)) {
      closeLists()
      html.push('<h3>' + inlineFormat(escapeHtml(trimmed.replace(/^##\s+/, ''))) + '</h3>')
      i++
      continue
    }
    if (/^#\s+/.test(trimmed)) {
      closeLists()
      html.push('<h2>' + inlineFormat(escapeHtml(trimmed.replace(/^#\s+/, ''))) + '</h2>')
      i++
      continue
    }
    if (/^>\s?/.test(trimmed)) {
      closeLists()
      html.push('<blockquote>' + inlineFormat(escapeHtml(trimmed.replace(/^>\s?/, ''))) + '</blockquote>')
      i++
      continue
    }
    if (/^[-*]\s+/.test(trimmed)) {
      if (inOl) {
        html.push('</ol>')
        inOl = false
      }
      if (!inUl) {
        html.push('<ul>')
        inUl = true
      }
      html.push('<li>' + inlineFormat(escapeHtml(trimmed.replace(/^[-*]\s+/, ''))) + '</li>')
      i++
      continue
    }
    if (/^\d+\.\s+/.test(trimmed)) {
      if (inUl) {
        html.push('</ul>')
        inUl = false
      }
      if (!inOl) {
        html.push('<ol>')
        inOl = true
      }
      html.push('<li>' + inlineFormat(escapeHtml(trimmed.replace(/^\d+\.\s+/, ''))) + '</li>')
      i++
      continue
    }
    if (trimmed === '') {
      closeLists()
      html.push('<br/>')
      i++
      continue
    }
    closeLists()
    html.push('<p>' + inlineFormat(escapeHtml(trimmed)) + '</p>')
    i++
  }
  closeLists()
  return html.join('')
}

export default {
  renderSimpleMarkdown: renderSimpleMarkdown
}



// WEBPACK FOOTER //
// ./src/utils/simpleMarkdown.js